import { memo } from 'react';

import { useScopedTranslate } from '@locale/translate';

import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'extract_text';

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={t('title')}
        descriptionText={node.data?.description}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Extract text',
  },
};
